module.exports = __webpack_public_path__ + "img/materials_jp.f8989f3.jpg";